<template>
  <div id="app">
    <Header></Header>
    <Top></Top>
    <form name="applyForm">
      <input
        type="hidden"
        name="zf_referrer_name"
        value=""
      /><!-- To Track referrals , place the referrer name within the " " in the above hidden input field -->
      <input
        type="hidden"
        name="zf_redirect_url"
        value="https://mqnavi.com/lp/thanks.html"
      /><!-- To redirect to a specific page after record submission , place the respective url within the " " in the above hidden input field -->
      <input
        type="hidden"
        name="zc_gad"
        value=""
      /><!-- If GCLID is enabled in Zoho CRM Integration, click details of AdWords Ads will be pushed to Zoho CRM -->
      <input
        type="hidden"
        name="SingleLine"
        value="MQLP"
        fieldType="1"
        maxlength="255"
        placeholder=""
      />
      <!-- utm_source -->
      <input
        type="hidden"
        name="SingleLine1"
        :value="form.SingleLine1"
        fieldType="1"
        maxlength="255"
      />
      <!-- utm_medium -->
      <input
        type="hidden"
        name="SingleLine2"
        :value="form.SingleLine2"
        fieldType="1"
        maxlength="255"
      />
      <!-- utm_campaign -->
      <input
        type="hidden"
        name="SingleLine3"
        :value="form.SingleLine3"
        fieldType="1"
        maxlength="255"
      />
      <!-- utm_term -->
      <input
        type="hidden"
        name="SingleLine4"
        :value="form.SingleLine4"
        fieldType="1"
        maxlength="255"
      />
      <!-- utm_content -->
      <input
        type="hidden"
        name="SingleLine5"
        :value="form.SingleLine5"
        fieldType="1"
        maxlength="255"
      />
      <StepContainer
        id="step1"
        btnId="toStep2"
        btnText="次の質問へ"
        :validate="error.Radio.validate"
        @showNextStep="showNextStep"
      >
        <template #operator-component>
          <Operator
            text="造園施工管理の実務経験をお持ちですか？"
          ></Operator>
        </template>
        <template #form-component>
          <FormLabel
            formId="Radio"
            label=""
            :errorMessage="error.Radio.message"
          ></FormLabel>
          <FormRadio
            v-model="form.Radio"
            @checkValidate="checkValidate"
            name="Radio"
            :options="careerOptions"
          ></FormRadio>
        </template>
      </StepContainer>
      <StepContainer
        id="step2"
        btnId="toStep3"
        btnText="次の質問へ"
        :validate="error.prefecture.validate"
        @showNextStep="showNextStep"
        v-if="appear.step2"
      >
        <template #operator-component>
          <Operator text="お住まいの都道府県をお教え下さい。"></Operator>
        </template>
        <template #form-component>
          <p class="sentence-paragraph">
            <font-awesome-icon
              icon="lock"
              class="icon"
            />個人情報は公開されません
          </p>
          <FormLabel
            formId="prefecture"
            label="都道府県"
            :errorMessage="error.prefecture.message"
          ></FormLabel>
          <FormSelect
            v-model="form.Dropdown"
            @checkValidate="checkValidate"
            id="prefecture"
            name="Dropdown"
            :options="prefectureOptions"
          ></FormSelect>
        </template>
      </StepContainer>
      <StepContainer
        id="step3"
        btnId="toStep4"
        btnText="次の質問へ"
        :validate="
          error.birthYear.validate &&
          error.nameFirst.validate &&
          error.nameLast.validate
        "
        @showNextStep="showNextStep"
        v-if="appear.step3"
      >
        <template #operator-component>
          <Operator text="生まれ年、お名前をお教え下さい。"></Operator>
        </template>
        <template #form-component>
          <FormLabel
            formId="birthYear"
            label="生まれ年"
            :errorMessage="error.birthYear.message"
          ></FormLabel>
          <FormSelect
            v-model="form.Dropdown1"
            @checkValidate="checkValidate"
            id="birthYear"
            name="Dropdown1"
            :options="birthYearOptions"
          ></FormSelect>
          <FormLabel
            formId="nameLast"
            label="お名前"
            :errorMessage="`${error.nameLast.message} ${error.nameFirst.message}`"
          ></FormLabel>
          <FormInput
            v-model="form.Name_Last"
            @checkValidate="checkValidate"
            placeholder="姓"
            id="nameLast"
            name="Name_Last"
            type="text"
            maxlength="255"
            fieldType="7"
          ></FormInput>
          <FormInput
            v-model="form.Name_First"
            @checkValidate="checkValidate"
            placeholder="名"
            id="nameFirst"
            name="Name_First"
            type="text"
            maxlength="255"
            fieldType="7"
          ></FormInput>
        </template>
      </StepContainer>
      <StepContainer
        id="step4"
        btnId="submit"
        btnText="利用規約に同意して登録する"
        :validate="
          !Object.values(this.error)
            .map((item) => item.validate)
            .includes(false)
        "
        v-if="appear.step4"
        @submitForm="submit"
        :submitStatus="submitStatus"
      >
        <template #operator-component>
          <Operator text="ご連絡先をお教え下さい。"></Operator>
        </template>
        <template #form-component>
          <FormLabel
            formId="international_PhoneNumber_countrycode"
            label="携帯電話番号"
            :errorMessage="error.international_PhoneNumber_countrycode.message"
          ></FormLabel>
          <FormInput
            v-model="form.PhoneNumber_countrycode"
            @checkValidate="checkValidate"
            placeholder="携帯電話番号をご入力ください"
            maxLength="20"
            compname="PhoneNumber"
            phoneFormat="1"
            isCountryCodeEnabled="false"
            fieldType="11"
            id="international_PhoneNumber_countrycode"
            name="PhoneNumber_countrycode"
            type="text"
          ></FormInput>
          <FormLabel
            formId="mail"
            label="メールアドレス"
            :errorMessage="error.mail.message"
          ></FormLabel>
          <FormInput
            v-model="form.Email"
            @checkValidate="checkValidate"
            placeholder="メールアドレスをご入力ください"
            fieldType="9"
            maxlength="255"
            id="mail"
            name="Email"
            type="text"
          ></FormInput>
        </template>
      </StepContainer>
    </form>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./components/Header";
import Top from "./components/Top";
import Operator from "./components/Operator";
import StepContainer from "./components/StepContainer";
import FormLabel from "./components/FormLabel";
import FormRadio from "./components/FormRadio";
import FormSelect from "./components/FormSelect";
import FormInput from "./components/FormInput";
import Footer from "./components/Footer";

export default {
  name: "App",
  components: {
    Header,
    Top,
    StepContainer,
    FormLabel,
    FormRadio,
    FormSelect,
    FormInput,
    Operator,
    Footer,
  },
  data() {
    return {
      form: {
        SingleLine1: "",
        SingleLine2: "",
        SingleLine3: "",
        SingleLine4: "",
        SingleLine5: "",
        Radio: "",
        Dropdown: "", // 都道府県
        Dropdown1: "", // 生年月日
        Name_First: "",
        Name_Last: "",
        PhoneNumber_countrycode: "",
        Email: "",
      },
      appear: {
        step2: false,
        step3: false,
        step4: false,
      },
      error: {
        Radio: { message: "", validate: false },
        prefecture: { message: "", validate: false },
        birthYear: { message: "", validate: false },
        nameFirst: { message: "", validate: false },
        nameLast: { message: "", validate: false },
        international_PhoneNumber_countrycode: { message: "", validate: false },
        mail: { message: "", validate: false },
      },
      careerOptions: [
        {
          id: "Radio_1",
          label: "経験あり",
          value: "あり",
        },
        {
          id: "Radio_2",
          label: "経験なし",
          value: "なし",
        },
      ],
      prefectureOptions: [
        {
          value: "",
          label:
            "\u90fd\u9053\u5e9c\u770c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044",
        },
        {
          value: "\u5317\u6d77\u9053",
          label: "\u5317\u6d77\u9053",
        },
        {
          value: "\u9752\u68ee\u770c",
          label: "\u9752\u68ee\u770c",
        },
        {
          value: "\u5ca9\u624b\u770c",
          label: "\u5ca9\u624b\u770c",
        },
        {
          value: "\u5bae\u57ce\u770c",
          label: "\u5bae\u57ce\u770c",
        },
        {
          value: "\u79cb\u7530\u770c",
          label: "\u79cb\u7530\u770c",
        },
        {
          value: "\u5c71\u5f62\u770c",
          label: "\u5c71\u5f62\u770c",
        },
        {
          value: "\u798f\u5cf6\u770c",
          label: "\u798f\u5cf6\u770c",
        },
        {
          value: "\u8328\u57ce\u770c",
          label: "\u8328\u57ce\u770c",
        },
        {
          value: "\u6803\u6728\u770c",
          label: "\u6803\u6728\u770c",
        },
        {
          value: "\u7fa4\u99ac\u770c",
          label: "\u7fa4\u99ac\u770c",
        },
        {
          value: "\u57fc\u7389\u770c",
          label: "\u57fc\u7389\u770c",
        },
        {
          value: "\u5343\u8449\u770c",
          label: "\u5343\u8449\u770c",
        },
        {
          value: "\u6771\u4eac\u90fd",
          label: "\u6771\u4eac\u90fd",
        },
        {
          value: "\u795e\u5948\u5ddd\u770c",
          label: "\u795e\u5948\u5ddd\u770c",
        },
        {
          value: "\u65b0\u6f5f\u770c",
          label: "\u65b0\u6f5f\u770c",
        },
        {
          value: "\u5bcc\u5c71\u770c",
          label: "\u5bcc\u5c71\u770c",
        },
        {
          value: "\u77f3\u5ddd\u770c",
          label: "\u77f3\u5ddd\u770c",
        },
        {
          value: "\u798f\u4e95\u770c",
          label: "\u798f\u4e95\u770c",
        },
        {
          value: "\u5c71\u68a8\u770c",
          label: "\u5c71\u68a8\u770c",
        },
        {
          value: "\u9577\u91ce\u770c",
          label: "\u9577\u91ce\u770c",
        },
        {
          value: "\u5c90\u961c\u770c",
          label: "\u5c90\u961c\u770c",
        },
        {
          value: "\u9759\u5ca1\u770c",
          label: "\u9759\u5ca1\u770c",
        },
        {
          value: "\u611b\u77e5\u770c",
          label: "\u611b\u77e5\u770c",
        },
        {
          value: "\u4e09\u91cd\u770c",
          label: "\u4e09\u91cd\u770c",
        },
        {
          value: "\u6ecb\u8cc0\u770c",
          label: "\u6ecb\u8cc0\u770c",
        },
        {
          value: "\u4eac\u90fd\u5e9c",
          label: "\u4eac\u90fd\u5e9c",
        },
        {
          value: "\u5927\u962a\u5e9c",
          label: "\u5927\u962a\u5e9c",
        },
        {
          value: "\u5175\u5eab\u770c",
          label: "\u5175\u5eab\u770c",
        },
        {
          value: "\u5948\u826f\u770c",
          label: "\u5948\u826f\u770c",
        },
        {
          value: "\u548c\u6b4c\u5c71\u770c",
          label: "\u548c\u6b4c\u5c71\u770c",
        },
        {
          value: "\u9ce5\u53d6\u770c",
          label: "\u9ce5\u53d6\u770c",
        },
        {
          value: "\u5cf6\u6839\u770c",
          label: "\u5cf6\u6839\u770c",
        },
        {
          value: "\u5ca1\u5c71\u770c",
          label: "\u5ca1\u5c71\u770c",
        },
        {
          value: "\u5e83\u5cf6\u770c",
          label: "\u5e83\u5cf6\u770c",
        },
        {
          value: "\u5c71\u53e3\u770c",
          label: "\u5c71\u53e3\u770c",
        },
        {
          value: "\u5fb3\u5cf6\u770c",
          label: "\u5fb3\u5cf6\u770c",
        },
        {
          value: "\u9999\u5ddd\u770c",
          label: "\u9999\u5ddd\u770c",
        },
        {
          value: "\u611b\u5a9b\u770c",
          label: "\u611b\u5a9b\u770c",
        },
        {
          value: "\u9ad8\u77e5\u770c",
          label: "\u9ad8\u77e5\u770c",
        },
        {
          value: "\u798f\u5ca1\u770c",
          label: "\u798f\u5ca1\u770c",
        },
        {
          value: "\u4f50\u8cc0\u770c",
          label: "\u4f50\u8cc0\u770c",
        },
        {
          value: "\u9577\u5d0e\u770c",
          label: "\u9577\u5d0e\u770c",
        },
        {
          value: "\u718a\u672c\u770c",
          label: "\u718a\u672c\u770c",
        },
        {
          value: "\u5927\u5206\u770c",
          label: "\u5927\u5206\u770c",
        },
        {
          value: "\u5bae\u5d0e\u770c",
          label: "\u5bae\u5d0e\u770c",
        },
        {
          value: "\u9e7f\u5150\u5cf6\u770c",
          label: "\u9e7f\u5150\u5cf6\u770c",
        },
        {
          value: "\u6c96\u7e04\u770c",
          label: "\u6c96\u7e04\u770c",
        },
      ],
      birthYearOptions: [
        {
          label: "生まれた年を選択してください",
          value: "",
        },
        {
          label: "2020年",
          value: 2020,
        },
        {
          label: "2019年",
          value: 2019,
        },
        {
          label: "2018年",
          value: 2018,
        },
        {
          label: "2017年",
          value: 2017,
        },
        {
          label: "2016年",
          value: 2016,
        },
        {
          label: "2015年",
          value: 2015,
        },
        {
          label: "2014年",
          value: 2014,
        },
        {
          label: "2013年",
          value: 2013,
        },
        {
          label: "2012年",
          value: 2012,
        },
        {
          label: "2011年",
          value: 2011,
        },
        {
          label: "2010年",
          value: 2010,
        },
        {
          label: "2009年",
          value: 2009,
        },
        {
          label: "2008年",
          value: 2008,
        },
        {
          label: "2007年",
          value: 2007,
        },
        {
          label: "2006年",
          value: 2006,
        },
        {
          label: "2005年",
          value: 2005,
        },
        {
          label: "2004年",
          value: 2004,
        },
        {
          label: "2003年",
          value: 2003,
        },
        {
          label: "2002年",
          value: 2002,
        },
        {
          label: "2001年",
          value: 2001,
        },
        {
          label: "2000年",
          value: 2000,
        },
        {
          label: "1999年",
          value: 1999,
        },
        {
          label: "1998年",
          value: 1998,
        },
        {
          label: "1997年",
          value: 1997,
        },
        {
          label: "1996年",
          value: 1996,
        },
        {
          label: "1995年",
          value: 1995,
        },
        {
          label: "1994年",
          value: 1994,
        },
        {
          label: "1993年",
          value: 1993,
        },
        {
          label: "1992年",
          value: 1992,
        },
        {
          label: "1991年",
          value: 1991,
        },
        {
          label: "1990年",
          value: 1990,
        },
        {
          label: "1989年",
          value: 1989,
        },
        {
          label: "1988年",
          value: 1988,
        },
        {
          label: "1987年",
          value: 1987,
        },
        {
          label: "1986年",
          value: 1986,
        },
        {
          label: "1985年",
          value: 1985,
        },
        {
          label: "1984年",
          value: 1984,
        },
        {
          label: "1983年",
          value: 1983,
        },
        {
          label: "1982年",
          value: 1982,
        },
        {
          label: "1981年",
          value: 1981,
        },
        {
          label: "1980年",
          value: 1980,
        },
        {
          label: "1979年",
          value: 1979,
        },
        {
          label: "1978年",
          value: 1978,
        },
        {
          label: "1977年",
          value: 1977,
        },
        {
          label: "1976年",
          value: 1976,
        },
        {
          label: "1975年",
          value: 1975,
        },
        {
          label: "1974年",
          value: 1974,
        },
        {
          label: "1973年",
          value: 1973,
        },
        {
          label: "1972年",
          value: 1972,
        },
        {
          label: "1971年",
          value: 1971,
        },
        {
          label: "1970年",
          value: 1970,
        },
        {
          label: "1969年",
          value: 1969,
        },
        {
          label: "1968年",
          value: 1968,
        },
        {
          label: "1967年",
          value: 1967,
        },
        {
          label: "1966年",
          value: 1966,
        },
        {
          label: "1965年",
          value: 1965,
        },
        {
          label: "1964年",
          value: 1964,
        },
        {
          label: "1963年",
          value: 1963,
        },
        {
          label: "1962年",
          value: 1962,
        },
        {
          label: "1961年",
          value: 1961,
        },
        {
          label: "1960年",
          value: 1960,
        },
        {
          label: "1959年",
          value: 1959,
        },
        {
          label: "1958年",
          value: 1958,
        },
        {
          label: "1957年",
          value: 1957,
        },
        {
          label: "1956年",
          value: 1956,
        },
        {
          label: "1955年",
          value: 1955,
        },
        {
          label: "1954年",
          value: 1954,
        },
        {
          label: "1953年",
          value: 1953,
        },
        {
          label: "1952年",
          value: 1952,
        },
        {
          label: "1951年",
          value: 1951,
        },
        {
          label: "1950年",
          value: 1950,
        },
        {
          label: "1949年",
          value: 1949,
        },
        {
          label: "1948年",
          value: 1948,
        },
        {
          label: "1947年",
          value: 1947,
        },
        {
          label: "1946年",
          value: 1946,
        },
        {
          label: "1945年",
          value: 1945,
        },
        {
          label: "1944年",
          value: 1944,
        },
        {
          label: "1943年",
          value: 1943,
        },
        {
          label: "1942年",
          value: 1942,
        },
        {
          label: "1941年",
          value: 1941,
        },
        {
          label: "1940年",
          value: 1940,
        },
        {
          label: "1939年",
          value: 1939,
        },
        {
          label: "1938年",
          value: 1938,
        },
        {
          label: "1937年",
          value: 1937,
        },
        {
          label: "1936年",
          value: 1936,
        },
        {
          label: "1935年",
          value: 1935,
        },
        {
          label: "1934年",
          value: 1934,
        },
        {
          label: "1933年",
          value: 1933,
        },
        {
          label: "1932年",
          value: 1932,
        },
        {
          label: "1931年",
          value: 1931,
        },
        {
          label: "1930年",
          value: 1930,
        },
        {
          label: "1929年",
          value: 1929,
        },
        {
          label: "1928年",
          value: 1928,
        },
        {
          label: "1927年",
          value: 1927,
        },
        {
          label: "1926年",
          value: 1926,
        },
        {
          label: "1925年",
          value: 1925,
        },
        {
          label: "1924年",
          value: 1924,
        },
        {
          label: "1923年",
          value: 1923,
        },
        {
          label: "1922年",
          value: 1922,
        },
        {
          label: "1921年",
          value: 1921,
        },
        {
          label: "1920年",
          value: 1920,
        },
        {
          label: "1919年",
          value: 1919,
        },
        {
          label: "1918年",
          value: 1918,
        },
      ],
      submitStatus: {
        message: "",
        activateSubmit: true,
      },
    };
  },
  mounted() {
    // コードを取得
    const query = new URL(document.location).searchParams;

    // パラメータが存在しない場合は処理を行わない
    if (query.size < 1) {
      return;
    }

    // utm_source
    const utmSource = query.get("utm_source");
    if (utmSource) {
      this.form.SingleLine1 = utmSource;
    }

    // utm_medium
    const utmMedium = query.get("utm_medium");
    if (utmMedium) {
      this.form.SingleLine2 = utmMedium;
    }

    // utm_campaign
    const utmCampaign = query.get("utm_campaign");
    if (utmCampaign) {
      this.form.SingleLine3 = utmCampaign;
    }

    // utm_term
    const utmTerm = query.get("utm_term");
    if (utmTerm) {
      this.form.SingleLine4 = utmTerm;
    }

    // utm_content
    const utmContent = query.get("utm_content");
    if (utmContent) {
      this.form.SingleLine5 = utmContent;
    }
  },
  methods: {
    showNextStep: function (e) {
      this.appear[e] = true;
    },
    checkValidate: function (e) {
      const id = e.id;
      const bool = e.bool;
      this.error[id].validate = bool;
      this.error[id].message = e.message;
    },
    submit() {
      document.applyForm.action =
        "https://forms.zohopublic.com/exflora/form/exflora2/formperma/kuuBRZnriFI5EvgQ-wPVQYx8SW7QZtGJIEp-j32fPDQ/htmlRecords/submit";
      document.applyForm.method = "POST";
      document.applyForm.submit();
    },
  },
};
</script>
<style lang="scss">
.sentence-paragraph {
  text-align: center;
  padding: 2rem 0;
}
.icon {
  margin: 0 0.5rem;
}
</style>
